// @core/api/endpoints/chat/delete_message.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/chat';

/**
 * Delete a message
 * Deletes a message from the conversation. The message is removed for all participants and cannot be recovered.
 */
export async function DeleteMessage(
  conversation_id: string,
  message_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
